import { getDisplayStatus } from "../pipeline";

export const DELETE_PROTECTED_STATUSES = new Set(["CONFIRMED", "VOIDED"]);

export const getIdsDeleteMode = (recordOrStatus) => {
    const status = typeof recordOrStatus === "string" ? recordOrStatus : recordOrStatus?.status;
    if (DELETE_PROTECTED_STATUSES.has(status)) return "protected";
    if (getDisplayStatus(status) === "PROCESSING") return "running";
    return "direct";
};

export const getSingleDeleteConfirm = (record) => {
    const filename = record?.original_filename || "该账单";
    const mode = getIdsDeleteMode(record);
    if (mode === "protected") {
        const statusText = record?.status === "VOIDED" ? "已作废" : "已确认入库";
        return {
            title: "已确认或已作废账单不可删除",
            description: `${filename} ${statusText}，不能通过账单列表删除。`,
            okText: "知道了",
        };
    }
    if (mode === "running") {
        return {
            title: "确认删除运行中的账单",
            description: `${filename} 仍在处理。删除时后端会先停止并失效关联执行，停止成功后才会删除。`,
            okText: "停止并删除",
        };
    }
    return {
        title: "确认删除账单",
        description: `确定要删除 ${filename} 吗？`,
        okText: "确认删除",
    };
};

export const summarizeDeleteResults = (results = []) => {
    const summary = {
        total: results.length,
        succeeded: 0,
        failed: 0,
        stoppedAndDeleted: 0,
        protected: 0,
        stopFailed: 0,
        notFound: 0,
    };

    results.forEach((item) => {
        if (item?.success) {
            summary.succeeded += 1;
            if (item.stopped_before_delete) summary.stoppedAndDeleted += 1;
            return;
        }
        summary.failed += 1;
        if (item?.code === "CONFIRMED_DELETE_BLOCKED") summary.protected += 1;
        if (item?.code === "STOP_FAILED") summary.stopFailed += 1;
        if (item?.code === "NOT_FOUND") summary.notFound += 1;
    });

    return summary;
};
